import LeavePackageDetail from 'src/pages/v2/HrTicket/LeavePackageDetail/LeavePackageDetail';

export default LeavePackageDetail;
